export default __webpack_public_path__ + "static/media/blue2.d0d7db20.png";